import '../../styles/button/section-header-button.css'
import {Link} from 'react-router-dom'
const SectionHeaderButton = ({children,navigate,disabled}) => {
  return (
    <Link to={navigate} className='section-header-button' disabled={disabled}>{children}</Link>
  )
}

export default SectionHeaderButton